export const DATE_FILTER = [
  { label: "Date", value: "All" },
  { label: "Today", value: new Date().toISOString().split("T")[0] },
  {
    label: "Yesterday",
    value: new Date(new Date().setDate(new Date().getDate() - 1))
      .toISOString()
      .split("T")[0],
  },
  {
    label: "Last 7 days",
    value: new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0],
  },
  {
    label: "Last 30 days",
    value: new Date(new Date().setDate(new Date().getDate() - 30))
      .toISOString()
      .split("T")[0],
  },
];

export const STATUS_FILTER = [
  { label: "Status", value: "All" },
  { label: "Pending", value: "pending" },
  { label: "Under Review", value: "under_review" },
  { label: "Resolved", value: "resolved" },
  { label: "Dismissed", value: "dismissed" },
];

export const REPORT_REASON_FILTER = [
  { label: "Report Reason", value: "All" },
  { label: "Inappropriate Content", value: "inappropriate_content" },
  { label: "Spam", value: "spam" },
  { label: "Harassment", value: "harassment" },
  { label: "Other", value: "other" },
];

export const CONTENT_TYPE_FILTER = [
  { label: "Content Type", value: "All" },
  { label: "Activity", value: "activity" },
  { label: "Chat", value: "activity_message" },
  { label: "Profile", value: "user" },
];
